import type { UserRole } from "@/mocks/auth";


export interface NavItem {
  path: string;
  label: string;
  icon: string;
  visibleFor: string[]; // roles that can see this nav item
}

export const navItems: NavItem[] = [
  { path: "/dashboard", label: "nav_dashboard", icon: "ri-dashboard-line", visibleFor: ["Government Health Officer", "Organization User", "Admin", "Viewer"] },
  { path: "/alerts", label: "nav_alerts", icon: "ri-alarm-warning-line", visibleFor: ["Government Health Officer", "Organization User", "Admin", "Viewer"] },
  { path: "/predictions", label: "nav_predictions", icon: "ri-line-chart-line", visibleFor: ["Government Health Officer", "Organization User", "Admin", "Viewer"] },
  { path: "/resources", label: "nav_resources", icon: "ri-archive-line", visibleFor: ["Government Health Officer", "Organization User", "Admin"] },
  { path: "/organizations", label: "nav_organizations", icon: "ri-building-2-line", visibleFor: ["Government Health Officer", "Admin"] },
  { path: "/reports", label: "nav_reports", icon: "ri-file-list-3-line", visibleFor: ["Government Health Officer", "Organization User", "Admin", "Viewer"] },
  { path: "/settings", label: "nav_settings", icon: "ri-settings-3-line", visibleFor: ["Government Health Officer", "Admin"] },
];

export function getVisibleNavItems(role?: UserRole): NavItem[] {
  if (!role) return [];
  return navItems.filter((item) => item.visibleFor.includes(role));
}

